jQuery( function ($) {

    $('.accordion-toggle').click( function () {
        $(this).toggleClass( 'accordion-open' ).next( '.accordion-content' ).slideToggle( 300 );
    });

});